import { SelectRateGroup } from '../SelectRateGroup'
import { ViewQuote } from './ViewQuote'
import { getSupplier } from 'store/supplier'
import { getRateGroup } from 'api/rateGroup'
import { checkAppVersion, profile } from 'store/profile'
// import { route } from 'mithril'
// import { getProductCategories } from 'api/product'
// import { getDashboard, dashboard } from 'store/dashboard'
// import forward from 'assets/forward.svg'

export const QuoteFinance = ({ attrs: { isRebate } }) => {
  let currentStep
  let rateGroup

  const NextStep = () => {
    if (!currentStep) {
      currentStep = 1
    } else {
      currentStep++
    }
  }

  // const PreviousStep = () => {
  //   if (!currentStep) {
  //     currentStep = 1
  //   } else {
  //     currentStep--
  //   }

  //   // If stepping back from the first step then go home
  //   if (currentStep === 0) {
  //     route.set('/')
  //   }
  // }

  // const SelectRateGroupId = (groupId) => {
  //   rateGroupId = groupId
  // }

  const SetRateGroup = (group) => {
    rateGroup = group
  }
  const supplier = getSupplier()

  if (!profile()) {
    m.route.set('/login')
  } else {
    checkAppVersion()
  }
  
  if (!supplier) {
    m.route.set('/')
  } else {

    // First time in check if supplier only has one offer, if so use t otherwise default to step 1 (select rate)
    if (!currentStep) {

      if (supplier.rateGroupId) {
      
      getRateGroup(supplier.rateGroupId).then((data) => {
        SetRateGroup(data)
        currentStep = 2
      })

    }
    else {
        currentStep = 1
      }
    }
  }

  return {
    view () {
      return m('.h-full.flex.flex-col.mx-auto', [

        currentStep === 1
          ? m(SelectRateGroup, { NextStep: NextStep, SetRateGroup: SetRateGroup, supplier: supplier, isFinanceCalculator: isRebate ? null : true, isRebateCalculator: isRebate ? true : null })
          : null,
        currentStep === 2
          ? m(ViewQuote, { NextStep: NextStep, supplier: supplier, rateGroup: rateGroup, isRebate: isRebate})
          : null
        // currentStep === 3
        //   ? m(ViewQuoteROI, { supplier: supplier, rateGroupId: rateGroupId })
        //   : null
      ])
    }
  }
}
